import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from './baseQuery';
import { Entrepreneur } from '../Model/Entrepreneur';
import { Accountant } from '../Model/Accountant';

type AuthenticationProps = {
  role: string | null;
  user: Entrepreneur & Accountant;
};

export const storeApi = createApi({
  reducerPath: 'api',
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 600,
  tagTypes: ['Accountant', 'Entrepreneur', 'BankAccount', 'Client', 'Company', 'File', 'Transaction'],
  endpoints: (builder) => ({
    login: builder.query<AuthenticationProps, { token: string }>({
      query: ({ token }) => {
        return {
          url: '/me',
          params: { token },
        };
      },
    }),
    reminder: builder.query<AuthenticationProps, { companyId: string }>({
      query: ({ companyId }) => {
        return {
          url: '/reminder',
          method: 'POST',
          body: { companyId },
        };
      },
    }),
  }),
});

export const { useLazyLoginQuery, useLazyReminderQuery } = storeApi;
